import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./style.css";
import ActionBar from "../../../components/ActionBar";
import CustomCard from "../../../components/Card";
import CardsContainer from "../../../components/CardsContainer";
import StyledCard from "../../../components/StyledCard";
import API from "../../../../API";
import Loader from "../Loader";
const Package = (props) => {
  const [procuringEntityPackage, setProcuringEntityPackage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [subProjectsList, setSubProjectsList] = useState([]);

  const history = useHistory();

  const {
    match: { url, params },
  } = props;

  const { packageId } = params;

  console.log("PPP:procuringEntityPackage", procuringEntityPackage);

  const handleCardsDetails = (title) => {
    switch (title) {
      case "Equipments Mobilization":
        history.push({ pathname: `${url}/equipment-mobilization` });
        break;
      case "Mobilization of Staff":
        history.push({ pathname: `${url}/staff` });
        break;
      case "Work Summary":
        history.push({ pathname: `${url}/work-summary` });
        break;
      case "Financial Status":
        history.push({ pathname: `${url}/financial-status` });
        break;
      case "Challenges in Project Implementation":
        history.push({ pathname: `${url}/challenges-implementation` });
        break;
      case "Grievances Information":
        history.push({ pathname: `${url}/Grivences` });
        break;
      case "Incidents or Accidents":
        history.push({ pathname: `${url}/incidents-accidents` });
        break;
      case "Status of Relocation of Utilities":
        history.push({ pathname: `${url}/status-relocation` });
        break;
      case "Outstanding RAP Implementation":
        history.push({ pathname: `${url}/rap_trp_implementation` });
        break;
      case "Outstanding TRP Implementation":
        history.push({ pathname: `${url}/trp_trp_implementation` });
        break;
      case "Material Mobilized, Testing & Approval":
        history.push({ pathname: `${url}/material_Mobilized_Testing` });
        break;
      case "ESS":
        history.push({ pathname: `${url}/enviromental-safeguards` });
        break;
      case "Social Safeguards Concerns":
        history.push({ pathname: `${url}/social-safeguards` });
        break;
      case "Contractor's Contract Infomation":
        history.push({ pathname: `${url}/contract-details` });
        break;
      case "Quality Controls":
        history.push({ pathname: `${url}/quality-controls` });
        break;
      default:
        return null;
    }
  };

  const progress_and_issues = [
    "Work Summary",
    "Challenges in Project Implementation",
    "Status of Relocation of Utilities",
    "Quality Controls",
    "Financial Status",
    "Equipments Mobilization",
    "Mobilization of Staff",
    "Material Mobilized, Testing & Approval",
  ];

  const ohs_and_safeguards = [
    "ESS",
    "Grievances Information",
    "Incidents or Accidents",
    "Outstanding RAP Implementation",
    "Outstanding TRP Implementation",
  ];

  const contract_info_and_mobilization_status = [
    "Contractor's Contract Infomation",
  ];
  const subProjects = (subProjectsList || [])
    .filter((sp) => Number(sp?.alias_for || 0) === 0 && sp.progress)
    .map((subProject) => {
      const p = subProject.progress?.[0];
      return {
        id: subProject.id,
        imageUrl: p?.georeferenced_photos?.[0]?.image_url || null,
        title: subProject?.name,
        distance: p?.target_quantity ?? '-', 
        progress: p?.progress_towards_target ?? 0,
        remark: p?.remarks ?? '',
        unit: p?.unit_of_target ?? '-',    
      };
    });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      API.getPackage(packageId),
      API.getSubProjects({ "filter[procuring_entity_package_id]": packageId }),
    ])
      .then(([pkgRes, spRes]) => {
        try {
          setProcuringEntityPackage(pkgRes.data);
        } catch (e) {
          console.error(e);
        }
        try {
          const list = spRes?.data?.data || [];
          console.log("list", list);
          setSubProjectsList(Array.isArray(list) ? list : []);
        } catch (e) {
          console.error(e);
          setSubProjectsList([]);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
  }, [packageId]);

  if (loading) {
    return <Loader fontSize={50} />;
  }

  const onMapViewClick= () => history.push({ pathname: `${url}/map` })

  return (
    <div className="package-container">
      <ActionBar
        actionButtonProp={{
          title: `${procuringEntityPackage?.name || ''}`,
          arrActions: [
            {
              datatestid: "add-role-button",
              btnName: "View Sub-projects on Map",
              btnAction: onMapViewClick,
            },
          ],
        }}
      />

      <CardsContainer
        title="Subprojects"
        overflowX="auto"
      >
        {subProjects.map((subproject, index) => (
          console.log("subproject", subproject),
          <CustomCard
            key={index}
            data-cy="subproject-card"
            imageUrl={subproject.imageUrl}
            title={subproject.title}
            distance={subproject.distance}
            unit={subproject.unit}
            progress={subproject.progress}
            remark={subproject.remark}
            onClick={() => history.push({ pathname: `${url}/subprojects/${subproject.id}` })}
          />
        ))}
      </CardsContainer>
      <CardsContainer
        title="Contractor's Contract Information"
        overflowX="none"
        flexWrap="wrap"
      >
        {contract_info_and_mobilization_status.map((title, index) => (
          <StyledCard
            key={index}
            data-cy="contract-info-card"
            title={title}
            onClick={() => handleCardsDetails(title)}
          />
        ))}
      </CardsContainer>
      <CardsContainer
        title="Physical & Financial Progress"
        overflowX="none"
        flexWrap="wrap"
      >
        {progress_and_issues.map((title, index) => (
          <StyledCard
            key={index}
            data-cy="progress-issue-card"
            title={title}
            disabled={title === ""}
            onClick={() => handleCardsDetails(title)}
          />
        ))}
      </CardsContainer>
      <CardsContainer
        title="Environmental and Social Safeguards (ESS) Issues"
        overflowX="none"
        flexWrap="wrap"
      >
        {ohs_and_safeguards.map((title, index) => (
          <StyledCard
            key={index}
            data-cy="safeguard-card"
            title={title}
            onClick={() => handleCardsDetails(title)}
          />
        ))}
      </CardsContainer>
    </div>
  );
};

export default Package;
